<script generics="T" lang="ts">
	import LineLoader from '../loaders/LineLoader.svelte'
	import type { Readable } from 'svelte/store'

	interface Props {
		query: Readable<{
			isLoading: boolean
			isPending: boolean
			isSuccess: boolean
			isFetching: boolean
			data: T
		}>
		onSuccess?: (data: T) => void
		loading?: import('svelte').Snippet
		children?: import('svelte').Snippet<[{ data: T }]>
		error?: import('svelte').Snippet
	}

	let { query, loading, children, error, onSuccess = null }: Props = $props()

	$effect(() => {
		if ($query.isSuccess && !$query.isFetching) {
			onSuccess?.($query.data)
		}
	})
</script>

{#if ($query.isLoading || $query.isPending) && children}
	{#if loading}{@render loading()}{:else}
		<LineLoader />
	{/if}
{:else if $query.isSuccess}
	{@render children?.({ data: $query.data })}
{:else}
	{@render error?.()}
{/if}
